import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import OverviewComponent from '../components/overview';
import ResponsiveLayout from '../components/common/ResponsiveLayout';
import { useFeatureFlags } from '../contexts/FeatureFlagsContext';
import { FeatureFlags } from '../flags';
import { KEYSTONE_REDIRECT_URL } from '../config';

const Overview: React.FC = () => {
  const { hasFeature } = useFeatureFlags();
  const showNewOverview = hasFeature(FeatureFlags.NGW_OVERVIEW);

  useEffect(() => {
    if (!showNewOverview) {
      window.location.href = `${KEYSTONE_REDIRECT_URL}`;
    }
  }, [showNewOverview]);

  if (!showNewOverview) {
    return (
      <ResponsiveLayout>
        <Box sx={{ textAlign: 'center', maxWidth: '600px', p: 3 }}>
          <Typography variant="h4" gutterBottom>
            Redirecting to Listing Management...
          </Typography>
        </Box>
      </ResponsiveLayout>
    );
  }

  return <OverviewComponent />;
};

export default Overview;
